import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { IEmailConfirmation } from '../dialogs/confirm-email/interfaces/email-confirmation';
import { IMessageResult } from '../interfaces/message-result';
import { IProfile } from '../interfaces/profile';
import { PasswordModel } from '../models/password-model';
import { ProfileModel } from '../models/profile-model';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private apiPath: string = environment.apiUrl + 'profile/';

  constructor(private http: HttpClient) {}

  public get(): Observable<IProfile> {
    return this.http
      .get<IProfile>(this.apiPath, { withCredentials: true })
      .pipe(map((result) => result));
  }

  public update(model: ProfileModel): Observable<IMessageResult> {
    const headers = new HttpHeaders({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': 'application/json',
    });
    return this.http
      .post<IMessageResult>(this.apiPath, JSON.stringify(model), {
        headers,
        withCredentials: true,
      })
      .pipe(map((result) => result));
  }

  public changePassword(model: PasswordModel): Observable<IMessageResult> {
    const headers = new HttpHeaders({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': 'application/json',
    });
    return this.http
      .post<IMessageResult>(this.apiPath + 'password', JSON.stringify(model), {
        headers,
        withCredentials: true,
      })
      .pipe(map((result) => result));
  }

  public requestConfirmationEmail(): Observable<IEmailConfirmation> {
    const headers = new HttpHeaders({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': 'application/json',
    });

    return this.http
      .post<IEmailConfirmation>(this.apiPath + 'request-confirmation', null, {
        headers,
        withCredentials: true,
      })
      .pipe(map((result) => result));
  }

  public validateConfirmationCode(code: string): Observable<boolean> {
    const headers = new HttpHeaders({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': 'application/json',
    });
    return this.http
      .post<boolean>(
        this.apiPath + `validate-confirmation?code=${code}`,
        null,
        { headers, withCredentials: true }
      )
      .pipe(map((result) => result));
  }

  public invalidateToken(): Observable<IMessageResult> {
    const headers = new HttpHeaders({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': 'application/json',
    });
    return this.http
      .post<IMessageResult>(this.apiPath + 'invalidate-token', '', {
        headers,
        withCredentials: true,
      })
      .pipe(map((result) => result));
  }
}
